/* eslint-disable react/no-unescaped-entities */
import { memo } from 'react'
import { Typography } from '@mui/material'
import CategoryLayout from 'components/Layout/Category'

import AgbText from 'components/Smava/AGB/AgbText'

const Agb = () => {
  return (
    <CategoryLayout>
      <Typography color="grey.600">
        <AgbText ctaButtonLabel="Weiter" />
      </Typography>
    </CategoryLayout>
  )
}

export default memo(Agb)
